export const saveColumns = ({ section }) => state => {
  const columns = JSON.parse(window.localStorage.getItem("columns")) || {};

  columns[section] = state[section].columns;

  window.localStorage.setItem("columns", JSON.stringify(columns));
};
